<template>
  <div class="break-words w-full">
    <div v-html="result"/>
  </div>
</template>

<script setup lang="ts">
import {getHighlighter} from "~/utils/markdownit";

const props = withDefaults(defineProps<{
  content: string,
  stream?: string,
  allowImages?: boolean
}>(), { allowImages: true })

const result = ref('')
const colorMode = useColorMode()

onMounted(() => {
  handleMarkdown('content')

  setTimeout(() => {
    updatePreStyles()
  }, 20)
})
async function getOrCreateHighlighter() {
  return getHighlighter(colorMode.preference, props.allowImages);
}

function handleMarkdown(type: 'stream' | 'content') {
  setTimeout(async () => {
    const md = await getOrCreateHighlighter();
    
    if (type == 'stream') {
      result.value = md.render(props.stream)
    } 
    if (type == 'content') {
      let message = prepareMarkdownForPreview(props.content);
      result.value = md.render(message)
      updatePreStyles()
    }
  }, 20);
}

watch(() => props.content, () => {
  handleMarkdown('content')
})

watch(() => props.stream, () => {
  handleMarkdown('stream')
})

watch(() => props.allowImages, () => {
  handleMarkdown(props.stream ? 'stream' : 'content')
})


function updatePreStyles() {
  setTimeout(() => {
    const preElements = document.querySelectorAll('pre.shiki')

    preElements.forEach(pre => {
      // set font size
      pre.style.fontSize = '15px'

      // inherit the background
      // pre.style.background = 'none'
      pre.style.background = '#333'

      // // set border color
      // if (document.documentElement.classList.contains('dark')) {
      //   pre.style.border = '1px solid #333'
      // } else {
      //   pre.style.border = '1px solid #eaeaea'
      // }

      // Check if a copy button already exists
      if (!pre.querySelector('button.copy-button')) {
        // create and append copy button
        const copyButton = document.createElement('button')
        copyButton.className = 'copy-button'
        copyButton.innerText = 'Copy'
        copyButton.style.position = 'absolute'
        copyButton.style.top = '5px'
        copyButton.style.right = '5px'
        copyButton.style.padding = '5px'
        copyButton.style.fontSize = '12px'
        copyButton.style.cursor = 'pointer'
        copyButton.addEventListener('click', () => {
          const codeElement = pre.querySelector('code')
          if (codeElement) {
            const codeText = codeElement.innerText
            copyToClipboard(codeText)
          }
        })
        pre.style.position = 'relative'
        pre.appendChild(copyButton)
      }
    })
  }, 200)
}

function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text).then(() => {
    showNotification('success', 'Copied to clipboard')
  }).catch(err => {
    console.error('Failed to copy: ', err)
  })
}
</script>

<style scoped>
pre {
  position: relative;
}

code {
  font-size: 15px;
}
</style>
